import { css, Z_INDEX_LIBRARY } from '@bts-web/utils-style-engine';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { FC, ReactNode } from 'react';

export interface IMenuProps {
  components: {
    buttonElement: ReactNode;
    menuContent: ReactNode;
  };
  dropdownMenuProps?: DropdownMenu.DropdownMenuContentProps;
}

export const Menu: FC<IMenuProps> = ({ components, dropdownMenuProps }) => {
  const { buttonElement, menuContent } = components;

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>{buttonElement}</DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <div
          style={{ zIndex: Z_INDEX_LIBRARY.OVERLAY }}
          className={css({
            position: 'fixed',
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.25)',
            top: 0,
          })}
        >
          <DropdownMenu.Content
            {...dropdownMenuProps}
            style={{
              willChange: 'transform, opacity',
              zIndex: Z_INDEX_LIBRARY.DROPDOWN,
              ...(dropdownMenuProps ? dropdownMenuProps.style : {}),
            }}
          >
            {menuContent}
          </DropdownMenu.Content>
        </div>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};
